module.exports = __webpack_public_path__ + "img/Cópia de Alls Technology.f972d415.jpg";